import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IoMdHome } from "react-icons/io";
import { FaHotel, FaUmbrellaBeach, FaHeart } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { MdCall } from "react-icons/md";
import { CiStreamOn } from "react-icons/ci";
import "./NavbarMain.css";

const NavbarMain = () => {
  return (
    <>
      <input type="checkbox" id="menuToggle" hidden />
      <label htmlFor="menuToggle" className="navbar-toggle">☰</label>

      <div className="Navbar_Main">
        <Container>
          <div className="Navbar_Main-MenuBar">
            <div className="Navbar_Main-LeftGroup">
              <Link to="/" className="logo-section">
                <img className="logo-main" src="/Images/tour/muktinath-logo.png" alt="Logo" />
             
              </Link>

              <div className="nav-links">
                <Link to="/" className="nav-item-link">
                  <IoMdHome className="nav-icon" />
                </Link>

                {/* International Dropdown */}

                <div className="nav-item-link dropdown">
                  <div className="dropdown-toggle">
                    Tour Destinations 
                  </div>
                  <div className="dropdown-menu">
                    <Link to="/kathmandu" className="dropdown-item">Kathmandu</Link>
                    <Link to="/pokhara" className="dropdown-item">Pokhara</Link>
                    <Link to="/manokamna" className="dropdown-item">Manokamna</Link>
                    <Link to="/lumbini" className="dropdown-item">Lumbini</Link>
                    <Link to="/muktinath" className="dropdown-item">Muktinath</Link>
                    <Link to="/chitwan" className="dropdown-item">Chitwan</Link>
                  </div>
                </div>

                {/* Domestic Dropdown */}
                <div className="nav-item-link dropdown">
                  <div className="">
                     Rental Cars
                  </div>
                  {/* <div className="dropdown-menu">
                    <Link to="/" className="dropdown-item">2 Nights 3 Days</Link>
                    <Link to="/" className="dropdown-item">3 Nights 4 Days</Link>
                    <Link to="/" className="dropdown-item">4 Nights 5 Days</Link>
                    <Link to="/" className="dropdown-item">5 Nights 6 Days</Link>
                    <Link to="/" className="dropdown-item">6 Nights 7 Days</Link>
                    <Link to="/" className="dropdown-item">7 Nights 8 Days</Link>
                    <Link to="/" className="dropdown-item">8 Nights 9 Days</Link>
                  </div> */}
                </div>

                <div className="nav-item-link dropdown">
                  <div className="">
                    Hotel Booking
                  </div>
                  {/* <div className="dropdown-menu">
                    <Link to="/" className="dropdown-item">2 Nights 3 Days</Link>
                    <Link to="/" className="dropdown-item">3 Nights 4 Days</Link>
                    <Link to="/" className="dropdown-item">4 Nights 5 Days</Link>
                    <Link to="/" className="dropdown-item">5 Nights 6 Days</Link>
                    <Link to="/" className="dropdown-item">6 Nights 7 Days</Link>
                    <Link to="/" className="dropdown-item">7 Nights 8 Days</Link>
                    <Link to="/" className="dropdown-item">8 Nights 9 Days</Link>
                  </div> */}
                </div>

                  <div className="nav-item-link dropdown">
                  <div className="">
                   <Link to="/about-us" className="footer-link">
                      About Us
                    </Link> 
                  </div>
                  {/* <div className="dropdown-menu">
                    <Link to="/scuba-diving" className="dropdown-item">Scuba Diving</Link>
                    <Link to="/sea-walk" className="dropdown-item">Sea Walk</Link>
                    <Link to="/snorkeling" className="dropdown-item">Snorkeling</Link>
                    <Link to="/paragliding" className="dropdown-item">Paragliding</Link>
                    <Link to="/sea-kart" className="dropdown-item">Sea Kart</Link>
                    <Link to="/banana-ride" className="dropdown-item">Banana Ride</Link>
                    <Link to="/jet-skie" className="dropdown-item">Jet-Skie</Link>
                  </div> */}
                </div>

                  {/* <div className="nav-item-link dropdown">
                  <div className="dropdown-toggle">
                    Ferries
                  </div>
                  <div className="dropdown-menu">
                    <Link to="/makruzz" className="dropdown-item">Makruzz</Link>
                    <Link to="/green-ocean" className="dropdown-item">Green Ocean</Link>
                    <Link to="/nautika" className="dropdown-item">Nautika</Link>
                  </div>
                </div> */}
                 <Link to="/contact" className="nav-item-link">
                Contact Us
              </Link>


              </div>
            </div>
              <div className="Navbar_Main-RightGroup">
                <a href="mailto:info@muktinathdarshan.com" className="contact-btn email-btn">
                  <FaEnvelope className="nav-icon" style={{ color: 'white' }} /> info@muktinathdarshan.com
                </a>

                <a href="tel:+919919222273 " className="contact-btn">
                  <MdCall className="nav-icon" style={{ color: 'white' }} /> +91-9919222273 
                </a>
              </div>
 
          </div>
        </Container>
      </div>
    </>
  );
};

export default NavbarMain;
